import { AIModel } from '../types';

export const AI_MODELS: AIModel[] = [
  // OpenAI Models
  {
    id: "gpt-4-turbo-preview",
    name: "GPT-4 Turbo",
    provider: "openai",
    description: "Latest and most capable GPT-4 model"
  },
  {
    id: "gpt-4",
    name: "GPT-4",
    provider: "openai",
    description: "Highly capable model for complex tasks"
  },
  {
    id: "gpt-3.5-turbo",
    name: "GPT-3.5 Turbo",
    provider: "openai",
    description: "Fast and cost-effective for most tasks"
  },
  // Anthropic Models
  {
    id: "claude-3-opus",
    name: "Claude 3 Opus",
    provider: "anthropic",
    description: "Most powerful Claude model"
  },
  {
    id: "claude-3-sonnet",
    name: "Claude 3 Sonnet",
    provider: "anthropic",
    description: "Balanced performance and efficiency"
  },
  {
    id: "claude-3-haiku",
    name: "Claude 3 Haiku",
    provider: "anthropic",
    description: "Fast and efficient for shorter tasks"
  },
  // Google Models
  {
    id: "gemini-1.0-pro",
    name: "Gemini 1.0 Pro",
    provider: "google",
    description: "Latest Gemini model for general tasks"
  },
  {
    id: "gemini-1.0-ultra",
    name: "Gemini 1.0 Ultra",
    provider: "google",
    description: "Most capable Gemini model"
  }
];